import script from "./Leverage.vue?vue&type=script&lang=ts&setup=true"
export * from "./Leverage.vue?vue&type=script&lang=ts&setup=true"

import "./Leverage.vue?vue&type=style&index=0&id=a81b1ea2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a81b1ea2"]])

export default __exports__